// 判断是否是生产环境
export const isProdFn = () => {
  const env = [
    'localhost:',
    '.dev.',
    '.test.',
    '.sit.',
    '.dev2.',
    '.demo.',
    '.gray.',
    '.nk.',
    '.bk.',
    '.uat.',
    '.uat2.',
  ]
  const hostName = window.location.hostname // 域名
  let isProd = true // 是否是生产环境
  for (let i = 0; i < env.length; i++) {
    if (hostName.indexOf(env[i]) != -1) {
      isProd = false
      break
    }
  }
  return isProd && process.env.NODE_ENV === 'production'
}
export default function initCollectEvent(opt = {}) {
  if (!isProdFn() && !opt.exceptProdAlsoRun) {
    /**
     * 默认非生产环境，不上报。可以减少不必要的计量收费。
     * exceptProdAlsoRun默认等于false。表示非生产环境不上报。为true表示非生产环境也上报，这通常可以在调试阶段时可以开启测试使用
     * */
    return
  }
  if (!opt.sysTitle) {
    throw new Error('埋点的initCollectEvent方法sysTitle必传')
  }
  window.collectEvent('init', {
    app_id: isProdFn() ? 629245 : 629244,
    channel: 'cn',
    autotrack: false, // 全埋点开关，true开启，false关闭
    spa: true, // 是否采集单页应用
    enable_stay_duration: true, // 开启停留时长
    log: true, // true:开启日志，false:关闭日志
    enable_debug: false, // 开启这个，就会在浏览中悬浮出现一个埋点的调试查看面板。但需要sdk的版本大于5.1.10
    enable_ab_test: true, // boolean类型，是否开启A/B实验功能
    enable_ab_visual: true, // boolean类型，按需开启，默认关闭，是否开启A/B实验的可视化编辑模式功能
    enable_multilink: true, // boolean类型，按需开启，默认关闭，是否开启A/B实验的多链接实验功能，默认为false
  })
  window.collectEvent('start')
  window.collectEvent('config', {
    ...opt,
    user_unique_id: opt.user_unique_id || null, // user_unique_id是预置的关键字，只要有值埋点处则标识为已登录
    sysTitle: opt.sysTitle || '',
    dstUserName: opt.dstUserName || '',
    dstUserPhone: opt.dstUserPhone || '',
    dstUserId: opt.dstUserId || '',
  })
}



// WEBPACK FOOTER //
// ./src/m-common/lib/collectPoint/index.js